/**
 * Single API base URL for POS, Kitchen, Waiter, and all KOT views.
 * Kitchen uses the same axios plugin → env.apiUrl (see src/plugins/axios.js).
 *
 * Resolution order:
 * 1. VUE_APP_API_URL from .env / .env.development / .env.production (build time)
 * 2. window.__GNANAMS_API_URL__ from public/runtime-config.js (runtime, no rebuild)
 * 3. Hostname fallback (localhost → local API, kot.gnanams.com → production API)
 */
const DEFAULT_LOCAL_API_URL = 'http://127.0.0.1:3000/api/v1.0/';
const DEFAULT_PROD_API_URL = 'https://api.gnanams.com/api/v1.0/';

function normalizeApiUrl(url) {
  if (!url || typeof url !== 'string') {
    return DEFAULT_LOCAL_API_URL;
  }
  const trimmed = url.trim();
  return trimmed.endsWith('/') ? trimmed : `${trimmed}/`;
}

function resolveApiUrl() {
  if (process.env.VUE_APP_API_URL) {
    return normalizeApiUrl(process.env.VUE_APP_API_URL);
  }

  if (typeof window !== 'undefined' && window.__GNANAMS_API_URL__) {
    return normalizeApiUrl(window.__GNANAMS_API_URL__);
  }

  if (typeof window !== 'undefined') {
    const { hostname } = window.location;
    if (
      hostname === 'localhost'
      || hostname === '127.0.0.1'
      || hostname.startsWith('192.168.')
    ) {
      return DEFAULT_LOCAL_API_URL;
    }
    if (hostname.endsWith('gnanams.com')) {
      return DEFAULT_PROD_API_URL;
    }
  }

  return DEFAULT_LOCAL_API_URL;
}

const apiUrl = resolveApiUrl();

export default {
  apiUrl,
};

export { apiUrl, resolveApiUrl };
